export interface PatientChartAttributePayload {
  chartAttributeId: string;
  value: string;
}

// A chart-attribute value after client-side encryption, ready to be sent nested
// in the response PATCH (see SignatureWizard). `value` is the ciphertext.
export interface EncryptedChartAttributePayload {
  chartAttributeId: string;
  value: string;
  encryptionKey: string;
}

export interface ResponseValue {
  data: string;
  customInput?: boolean;
}

export interface ResponsesPayload {
  questionId: string;
  // SC-688: FormNode.node_key — stable across revisions, lets report templates
  // resolve this answer without brittle question-body-text matching.
  nodeKey?: string;
  values: ResponseValue[];
  questionType: string;
  questionText: string;
  questionHelperText?: string;
  originalQuestionText?: string;
  originalQuestionHelperText?: string;
  // Bare pointers: the patient client must never learn what a mark means.
  annotations?: string[];
}

export interface WizardPayload {
  attachments: { [key: string]: string };
  responses: ResponsesPayload[];
  patientChartAttributes: PatientChartAttributePayload[];
  language?: string;
  // Every action crossed, unfiltered: the patient client must not be able to
  // tell which of them are flags.
  triggeredActionKeys?: string[];
}

export interface IconProps {
  children?: React.ReactNode;
  size?: number | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  viewBox?: string;
  fill?: string;
  stroke?: string;
  strokeWidth?: number;
  strokeLinecap?: 'round' | 'butt' | 'square';
  strokeLinejoin?: 'round' | 'miter' | 'bevel';
  [key: string]: any;
}

export enum GuidedBookingErrorCode {
  NO_TOKEN = 'NO_TOKEN',
  TOKEN_ALREADY_USED = 'TOKEN_ALREADY_USED',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  GENERAL_ERROR = 'GENERAL_ERROR',
}
